import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  TXTWCL_Chests_are_awarded_as_part_of__ELL,
  TXTWCL_Chests_are_awarded_from_the_St_ELL,
  TXTWCL_Chests_are_awarded_from_the_St_ELL_1
} from './ChestAwardMessage.messages.json';

const ChestAwardMessage: React.FC = () => {
  const license = useSelector(select.account.getLicense);

  switch (license) {
    case LicenceId.BG:
    case LicenceId.SPAIN:
      return <Translation {...TXTWCL_Chests_are_awarded_from_the_St_ELL_1} />;
    case LicenceId.SE:
      return <Translation {...TXTWCL_Chests_are_awarded_as_part_of__ELL} />;
    default:
      return <Translation {...TXTWCL_Chests_are_awarded_from_the_St_ELL} />;
  }
};

export default ChestAwardMessage;
